import React, { Component } from 'react';
import './App.css';
import { Route, Switch } from 'react-router-dom';
import { Home, SignOut, SignUp } from './pages';
import { Header } from './components';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header/>
        <span>PUBLIC={process.env.PUBLIC_URL}</span>

        <Switch>
          <Route exact path='/signup' component={SignUp}/>
          <Route exact path='/signout' component={SignOut}/>
          <Route path='/' component={Home}/>
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js